import React, { useRef } from "react";
import { IErrorResponse } from "../types/ErrorResponse";
import CademiController from "../controllers/MemberServiceController";
import { TMemberService } from "../types/MemberService";

export const useMemberServiceList = () => {
    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<TMemberService[]>([]);
    const [error, setError] = React.useState<string>('');

    const executing = useRef(false);

    const execute = async () => {
        if (!loading && !executing.current) {
            executing.current = true;
            try {
                setLoading(true);

                if (error !== '') {
                    setError('');
                }

                const response = await CademiController.getList();
                const responseError = response as IErrorResponse;
                const responseData = response as TMemberService[];

                if (responseError.code) {
                    setError(responseError.error);
                    setData([]);
                } else {
                    setData(responseData);
                }
            } catch (e) {
                var message = 'Erro não identificado';
                if (typeof e === "string") {
                    message = e.toUpperCase();
                } else if (e instanceof Error) {
                    const err = e as Error;
                    message = err.message;
                }
                setError(message);
            } finally {
                setLoading(false);
                executing.current = false;
            }
        }
    }

    React.useEffect(() => {
        execute();
    }, []);

    const clear = () => {
        setError('');
    }

    return {
        loading,
        data,
        error,
        execute,
        clear,
    };
}